import {Injectable} from '@angular/core';
import {MenuRoles} from '~local/app/shell/MenuRoles';
import {Permission} from '~shared/types/authentication.types';
import {UserRoleCode} from '~shared/types/user.types';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  public permissions: Permission[] = [];
  public roles: string[] = [];
  private source: string;

  public hasPermission(name: string): boolean {
    return this.permissions.some((v) => v === name);
  }

  public hasRoles(names: string[]) {
    return names.every(n => this.roles.some(r => r === n));
  }

  public hasSource(source: string): boolean {
    return source === this.source || this.hasPermission(Permission.DATA_ACROSS_WHITE_LABELS);
  }

  public setPermissions(roles: Array<UserRoleCode>, permissions: Array<Permission>, source: string) {
    this.roles = roles;
    this.permissions = permissions;
    this.source = source;
  }

  public canAccessRoute(routeUrl: string) {
    for (const key of Object.keys(MenuRoles)) {
      if (routeUrl.startsWith(MenuRoles[key].defaultRoute)) {
        return true;
      }
    }

    return false;
  }

  public getDefaultRouterLink() {
    if (!this.roles || this.roles.length === 0) {
      return '/about';
    }

    if (this.hasPermission(MenuRoles.DASHBOARD.roleName)) {
      return MenuRoles.DASHBOARD.defaultRoute;
    } else if (this.hasPermission(MenuRoles.KYC.roleName)) {
      return MenuRoles.KYC.defaultRoute;
    } else if (this.hasPermission(MenuRoles.ALL_TRANSACTIONS.roleName)) {
      return MenuRoles.ALL_TRANSACTIONS.defaultRoute;
    } else if (this.hasPermission(MenuRoles.BANK_IN_OUT.roleName)) {
      return MenuRoles.BANK_IN_OUT.defaultRoute;
    } else if (this.hasPermission(MenuRoles.CLIENTS.roleName)) {
      return MenuRoles.CLIENTS.defaultRoute;
    } else if (this.hasPermission(MenuRoles.CRYPTO_OUT.roleName)) {
      return MenuRoles.CRYPTO_OUT.defaultRoute;
    } else if (this.hasPermission(MenuRoles.USERS.roleName)) {
      return MenuRoles.USERS.defaultRoute;
    } else if (this.hasPermission(MenuRoles.CRYPTO_SERVICE.roleName)) {
      return MenuRoles.CRYPTO_SERVICE.defaultRoute;
    } else if (this.hasPermission(MenuRoles.EXCHANGE_SERVICE.roleName)) {
      return MenuRoles.EXCHANGE_SERVICE.defaultRoute;
    } else if (this.hasPermission(MenuRoles.SETTINGS.roleName)) {
      return MenuRoles.SETTINGS.defaultRoute;
    } else if (this.hasPermission(MenuRoles.STATISTICS.roleName)) {
      return MenuRoles.STATISTICS.defaultRoute;
    }

    return '/about';
  }
}
